import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { PortalCashTransactionDetail, type CashTransactionDetail } from '@kioskgaming/ui';
import AppLayout from '../../components/layout/AppLayout';
import { getSuperAgentCashTransactionDetail } from '../../services/api';

export default function CashTransactionDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [transaction, setTransaction] = useState<CashTransactionDetail | null>(null);

  useEffect(() => {
    if (!id) return;
    const createdAt = searchParams.get('created_at') ?? undefined;
    setLoading(true);
    void getSuperAgentCashTransactionDetail(id, createdAt)
      .then((res) => {
        if (!res.success) throw new Error(res.message || 'Could not load cash transaction');
        const d = (res as { data?: any }).data;
        if (!d?.transaction) {
          setTransaction(null);
          return;
        }
        const t = d.transaction;
        setTransaction({
          ...t,
          performedByType: String(t.performedByType ?? t.performed_by_type ?? 'super_agent'),
          performedById: String(t.performedById ?? t.performed_by_id ?? ''),
          buyerBalanceAfter: Number(t.buyerBalanceAfter ?? t.buyer_balance_after ?? 0),
          updatedAt: String(t.updatedAt ?? t.updated_at ?? ''),
          events: (d.events ?? []).map((ev: any) => ({
            id: String(ev.id),
            eventType: String(ev.eventType ?? ev.event_type ?? 'created'),
            actorType: String(ev.actorType ?? ev.actor_type ?? 'super_agent'),
            actorId: (ev.actorId ?? ev.actor_id) as string | null | undefined,
            payload: (ev.payload as Record<string, unknown>) ?? {},
            createdAt: String(ev.createdAt ?? ev.created_at ?? ''),
          })),
          creditTransaction: d.creditTransaction
            ? {
                id: String(d.creditTransaction.id),
                amount: Number(d.creditTransaction.amount ?? 0),
                balanceAfter: Number(d.creditTransaction.balanceAfter ?? d.creditTransaction.balance_after ?? 0),
                description: (d.creditTransaction.description as string) ?? null,
                createdAt: String(d.creditTransaction.createdAt ?? d.creditTransaction.created_at ?? ''),
              }
            : null,
          performedBy: d.performedBy
            ? {
                id: String(d.performedBy.id),
                email: (d.performedBy.email as string) ?? null,
                name: (d.performedBy.name as string) ?? null,
              }
            : null,
        });
      })
      .catch((e: unknown) => {
        setTransaction(null);
        toast.error(e instanceof Error ? e.message : 'Could not load cash transaction');
      })
      .finally(() => setLoading(false));
  }, [id, searchParams]);

  return (
    <AppLayout>
      <PortalCashTransactionDetail loading={loading} transaction={transaction} />
    </AppLayout>
  );
}

